import {Input, Radio, Switch} from 'antd'
import FieldsFactory from 'components/form/FieldsFactory'
import FormActionBar from 'components/form/FormActionBar'
import {createValue} from 'components/form/utils'
import {Formik} from 'formik'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import React, {useMemo} from 'react'
import {deepTranslate, NullAsDefault, shallowDiff} from 'views/Shared'
import {AdvancedFormFields} from '../custom/AdvancedFormGroup'
import {appClassNames} from '../custom/appClassNames'
import {SelectWidget} from '../custom/ReactSelectComponents'
import {createControlledFormField} from '../factory/createFormField'
import {renderIf, renderIfElse} from "../../Shared";
import classNames from "classnames";
import CustomRichEditor from "../custom/CustomRichEditor";
import {SlateRenderer} from "../../SlateEditor";
import {convertFromString, convertToString} from "../../SlateEditor/functions";
import {ModalEditorToolbar} from "../../SlateEditor/SlateEditor";
import {GiIronCross, GiSpellBook} from "react-icons/gi";
import {RiDoubleQuotesL, RiDoubleQuotesR} from "react-icons/ri";
import {GoDotFill} from "react-icons/go";

const formSchema = {
    title: {
        title: 'topic',
        children: [
            {
                name: 'title',
                component: createControlledFormField({
                    placeholder: 'ex: vegetarian, charity work',
                    Component: Input,
                }),
            },
        ],
    },
    description: {
        title: 'description topic',
        children: [
            {
                name: 'description',
                component: createControlledFormField({
                    rows: 2,
                    placeholder: 'description',
                    Component: Input.TextArea,
                }),
            },
        ],
    },
    content: {
        title: 'gospel message',
        children: [
            {
                name: 'content',
                component: createControlledFormField({
                    rows: 4,
                    placeholder: 'content',
                    Component: Input.TextArea,
                }),
            },
        ],
    },
    source_text: {
        title: 'quote',
        children: [
            {
                name: 'source_text',
                component: createControlledFormField({
                    placeholder: 'ex: pastor name',
                }),
            },
        ],
    },
    meditation: {
        title: 'the meditation on God Word',
        children: [
            {
                name: 'meditation',
                component: createControlledFormField({
                    rows: 4,
                    placeholder: 'meditation',
                    Component: Input.TextArea,
                }),
            },
        ],
    },
    meditation_content: {
        title: 'the meditation on God Word',
        children: [
            {
                name: 'meditation_content',
                component: ({name, value, form, onChange}) => {
                    const {resetKey} = form?.values ?? {}
                    return (
                        <CustomRichEditor
                            {...{
                                name,
                                value,
                                resetKey,
                                onChange,
                            }}
                            ToolbarComponent={ModalEditorToolbar}
                            placeholder="the meditation on God Word"
                        />
                    )
                },
            },
        ],
    },
    // language: {
    //     title: 'language',
    //     children: [
    //         {
    //             name: 'language',
    //             component: ({name, value, onChange}) => (
    //                 <Translate>
    //                     {(t) => (
    //                         <SelectWidget
    //                             name={name}
    //                             value={value}
    //                             allowClear={true}
    //                             className="w-full"
    //                             defaultValue="vi"
    //                             placeholder={t('language')}
    //                             onChange={(value) => {
    //                                 onChange(createValue(name, value ?? null))
    //                             }}
    //                             options={[
    //                                 {label: 'vietnamese', value: 'vi'},
    //                                 {label: 'english', value: 'en'},
    //                             ].map(deepTranslate(t))}
    //                         />
    //                     )}
    //                 </Translate>
    //             ),
    //         },
    //     ],
    // },
    language_sort_order: {
        inline: true,
        className: appClassNames.inline_2,
        children: [
            {
                label: 'language',
                name: 'language',
                component: ({name, value, onChange}) => (
                    <Translate>
                        {(t) => (
                            <SelectWidget
                                name={name}
                                value={value}
                                allowClear={true}
                                className="w-full"
                                defaultValue="vi"
                                placeholder={t('language')}
                                onChange={(value) => {
                                    onChange(createValue(name, value ?? null))
                                }}
                                options={[
                                    {label: 'vietnamese', value: 'vi'},
                                    {label: 'english', value: 'en'},
                                ].map(deepTranslate(t))}
                            />
                        )}
                    </Translate>
                ),
            },
            {
                label: 'sort order',
                name: 'sort_order',
                component: createControlledFormField({
                    type: 'number',
                    inputMode: 'numeric',
                    placeholder: 'order',
                }),
            },
        ],
    },
    is_default__active: {
        inline: true,
        className: 'grid grid-cols-2 gap-2',
        children: [
            {
                name: 'is_default',
                label: 'show default',
                component: ({name, value, onChange}) => (
                    <Translate>
                        {(t) => (
                            <Switch
                                checked={value}
                                unCheckedChildren={<span
                                    className="font-medium text-color-200 italic">{t('none')}</span>}
                                checkedChildren={<span className="font-medium italic">{t('default')}</span>}
                                onChange={(checked) => {
                                    onChange(createValue(name, Number(checked)))
                                }}
                            />
                        )}
                    </Translate>
                ),
            },
            {
                name: 'active',
                label: 'are in use',
                component: ({name, value, onChange}) => (
                    <Translate>
                        {(t) => (
                            <Radio.Group
                                // size="small"
                                buttonStyle="solid"
                                optionType="button"
                                className="custom-radio-button"
                                name={name}
                                value={value}
                                onChange={onChange}>
                                {[
                                    {label: 'no', value: 0},
                                    {label: 'yes', value: 1},
                                ].map(({label, value}, index) => (
                                    <Radio key={index} value={value}>
                                        {t(label)}
                                    </Radio>
                                ))}
                            </Radio.Group>
                        )}
                    </Translate>
                ),
            },
        ],
    },
}

export const ViewMeditation = ({item, onCancel = NullAsDefault}) => {
    const t = useTranslate()
    const {
        source_text,
        content,
        description,
        title,
        meditation_content,
        meditation
    } = item ?? {}

    if (_.isEmpty(item)) return null;

    const ContentWordOfGod = ({content}) => (
        <div className="flex flex-col mb-8">
            <div className="flex flex-center gap-2">
                <span style={{color: '#ccc'}}>{'------'}</span>
                <span className="font-bold text-base text-color-500 uppercase tracking-widest">
                    {t('words of god')}
                </span>
                <span style={{color: '#ccc'}}>{'------'}</span>
            </div>
            <div className="flex flex-col items-center gap-1 my-2">
                <div className="text-center font-bold text-lg text-primary italic">
                    <RiDoubleQuotesL size={14} className="mr-1 mb-1"/>
                    {content}
                    <RiDoubleQuotesR size={14} className="ml-1 mb-1"/>
                </div>
                <span className="font-bold text-xs text-color-000 italic">
                {`-- ${source_text} --`}
            </span>
            </div>
        </div>
    )

    const TitleTopic = () => (
        <div className="space-y-1">
            <div className="flex gap-2 text-green-700">
                <GiIronCross size={14} style={{marginTop: 5}}/>
                <span className="flex-1 font-bold text-lg leading-snug">
            {title}
        </span>
            </div>
            {/*{renderIf(*/}
            {/*  description,*/}
            {/*  <div className="ml-6 text-xs text-color-500 italic whitespace-pre-line">*/}
            {/*    {description}*/}
            {/*  </div>*/}
            {/*)}*/}
        </div>
    )

    return (
        <div className="flex flex-col 333-333">
            {renderIf(
                content,
                <ContentWordOfGod content={content?.split('"')}/>
            )}
            <div className="flex items-baseline gap-3 border-b mb-4">
                <GiSpellBook size={16} className="text-color-300"/>
                <div className="font-medium text-sm text-color-300 uppercase tracking-wide">
                    {t('meditate on God Word')}
                </div>
            </div>
            <div className="space-y-3">
                <TitleTopic/>
                {renderIf(
                    _.some([meditation_content, meditation]),
                    <div className="flex flex-col gap-1">
                        <div className="flex items-center gap-2">
                            <GoDotFill className="text-color-400"/>
                            <span className="text-color-400 whitespace-no-wrap italic">
                        {`${t('content a meditation')} : `}
                    </span>
                        </div>
                        {renderIfElse(
                            meditation_content,
                            <div style={{marginLeft: 15, fontSize: '1.125rem'}}>
                                <SlateRenderer value={convertFromString(meditation_content)}/>
                            </div>,
                            <span style={{marginLeft: 21, fontSize: '1.125rem'}}>
                        {meditation}
                    </span>,
                        )}
                    </div>
                )}
            </div>
            <div className="flex justify-end p-3 mt-6 md:mt-8">
                <span onClick={onCancel} className="font-medium text-color-200 hover:text-color-000 cursor-pointer">
                    {t('close')}
                </span>
            </div>
        </div>
    )
}

export const CreateCalendarLiturgicalText = ({
                                                 onCancel = NullAsDefault,
                                                 onSubmit = NullAsDefault,
                                             }) => {
    const t = useTranslate()

    const validate = (values) => {
        let errors = {}
        _.forEach(['sort_order'], (name) => {
            const value = _.get(values, name)
            if (_.isNaN(value)) {
                errors[name] = t('required field')
            }
        })
        _.forEach(['title', 'meditation_content', 'language'], (name) => {
            const value = _.get(values, name)
            if (_.isEmpty(value ?? undefined)) {
                errors[name] = t('required field')
            }
        })
        return errors
    }

    return (
        <Formik
            initialValues={{
                active: 0,
                is_default: 0,
                language: 'vi',
                sort_order: 0,
                title: undefined,
                description: undefined,
                content: undefined,
                source_text: undefined,
                meditation: undefined,
                meditation_content: undefined,
            }}
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            onSubmit={(values) => {
                const {meditation_content, ...rest} = values ?? {}

                onSubmit(_.omitBy(
                    {
                        ...rest,
                        meditation_content: meditation_content ? convertToString(meditation_content) : undefined,
                    },
                    _.isUndefined
                ))
            }}>
            <div className="flex flex-col space-y-2">
                <FieldsFactory
                    formSchema={[
                        formSchema.title,
                        formSchema.description,
                        formSchema.content,
                        formSchema.source_text,
                        // formSchema.language,
                        // formSchema.meditation,
                        formSchema.meditation_content
                    ]}
                />
                <AdvancedFormFields
                    formSchema={[formSchema.is_default__active, formSchema.language_sort_order]}
                />
                <FormActionBar submitText="create"/>
            </div>
        </Formik>
    )
}

export const EditCalendarLiturgicalText = ({
                                               item,
                                               onCancel = NullAsDefault,
                                               onSubmit = NullAsDefault,
                                           }) => {
    const t = useTranslate()

    const initialValues = useMemo(() => ({
        ...item,
        meditation_content: convertFromString(item?.meditation_content)
    }), [item])

    const validate = (values) => {
        let errors = {}
        _.forEach(['sort_order'], (name) => {
            const value = _.get(values, name)
            if (_.isNaN(value)) {
                errors[name] = t('required field')
            }
        })
        _.forEach(['title', 'meditation_content', 'language'], (name) => {
            const value = _.get(values, name)
            if (_.isEmpty(value ?? undefined)) {
                errors[name] = t('required field')
            }
        })
        return errors
    }

    return (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={initialValues}
            onSubmit={(values) => {
                const changes = shallowDiff(values, initialValues)
                const {meditation_content, ...rest} = changes ?? {}

                onSubmit(_.omitBy(
                    {
                        ...rest,
                        meditation_content: meditation_content ? convertToString(meditation_content) : undefined,
                    },
                    _.isUndefined
                ))
            }}>
            <div className="flex flex-col space-y-2">
                <FieldsFactory
                    formSchema={[
                        formSchema.title,
                        formSchema.description,
                        formSchema.content,
                        formSchema.source_text,
                        // formSchema.language,
                        // formSchema.meditation,
                        formSchema.meditation_content
                    ]}
                />
                <AdvancedFormFields
                    formSchema={[formSchema.is_default__active, formSchema.language_sort_order]}
                />
                <FormActionBar submitText="save"/>
            </div>
        </Formik>
    )
}


export const renderCalendarLiturgicalTextRow = ({renderContextMenu = NullAsDefault} = {}) => (item, index) => {
    const {
        title,
        description,
        language,
        sort_order,
        source_text,
        is_default,
        active,
        meditation,
        meditation_content
    } = item ?? {}

    const ItemRender = ({label, value, inline = false, className = 'text-sm text-color-100'}) => (
        renderIf(
            value,
            <Translate>
                {(t) => (
                    <div
                        className={classNames('flex gap-1 leading-tight', inline === true ? 'flex-row items-baseline' : 'flex-col')}>
                        <span className="text-xs text-color-500 italic leading-tight whitespace-no-wrap">
                            {`${t(label)} : `}
                        </span>
                        <span className={classNames('font-medium ml-2 whitespace-pre-line', className)}>
                            {value}
                        </span>
                    </div>
                )}
            </Translate>
        )
    )

    return (
        <Translate key={index}>
            {(t) => (
                <div
                    className="px-3 py-2 space-y-2 border border-color-50 hover:shadow-items rounded-md custom-item-render relative">
                    {is_default === 1 && (
                        <span
                            style={{padding: '4px 10px', marginLeft: '-0.75rem'}}
                            className="rounded-r-full font-semibold text-2xs text-primary bg-primary-50 italic">
                        {t('currently showing')}
                    </span>
                    )}
                    <div className="space-x-2 leading-tight">
                        <span className="text-xs text-color-500 italic leading-tight whitespace-no-wrap">
                            {`${t('topic')} : `}
                        </span>
                        <span className="font-bold text-sm text-color-000">
                            {title}
                        </span>
                    </div>
                    <ItemRender
                        label="quote"
                        value={source_text}
                        inline={true}
                        className="font-semibold text-xs text-blue-500 italic"
                    />
                    <div className="grid grid-cols-2 gap-1">
                        <ItemRender
                            label="show default"
                            value={is_default === 1 ? t('yes') : t('no')}
                            inline={true}
                            className={classNames('font-bold text-xs italic', is_default === 1 ? 'text-primary' : 'text-color-200')}
                        />
                        <ItemRender
                            label="status"
                            value={active === 1 ? t('active') : t('inactive')}
                            inline={true}
                            className={classNames('font-bold text-xs italic', is_default === 1 ? 'text-primary' : 'text-color-200')}
                        />
                    </div>
                    {_.isFunction(renderContextMenu) && (
                        <div className="absolute right-10 top-0 contextIcon">
                            {renderContextMenu(item)}
                        </div>
                    )}
                </div>
            )}
        </Translate>
    )
}